// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1n_Lq","title":"AfterBackImages_title__2NGr-","images":"AfterBackImages_images__1v0On"};